import { Box } from "@mui/material";

import TimelineMonthsRow from "./components/TimelineMonthsRow";
import TimelineWeekHeader from "./components/TimelineWeekHeader";

import { LABEL_WIDTH } from "./constants/timelineConstants";

export default function TimelineHeader({
  weeks,
  holidayWeeks,
  labelWidth = LABEL_WIDTH,
}) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        bgcolor: "background.paper",
      }}
    >
      {/* ===========================================
          MONTHS
      =========================================== */}

      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            width: labelWidth,
            flexShrink: 0,

            position: "sticky",
            left: 0,

            zIndex: 11,

            bgcolor: "background.paper",
          }}
        />

        <Box>
          <TimelineMonthsRow weeks={weeks} />
        </Box>
      </Box>

      {/* ===========================================
          WEEKS
      =========================================== */}

      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            width: labelWidth,
            flexShrink: 0,

            position: "sticky",
            left: 0,

            zIndex: 11,

            bgcolor: "background.paper",

            display: "flex",
            alignItems: "center",

            fontWeight: 600,
          }}
        >
          WOCHEN
        </Box>

        <Box>
          <TimelineWeekHeader weeks={weeks} holidayWeeks={holidayWeeks} />
        </Box>
      </Box>
    </Box>
  );
}
